import { render } from "./HeroiconsOutlineDownload.vue?vue&type=template&id=29dca540"
const script = {}

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineDownload.vue"]])

export default __exports__